export default [
  {
    path: "/stands",
    name: "ListStand",
    component: () => import("@/views/stand/list-stand.vue"),
    meta: {
      pageTitle: "Gestione Stand",
      breadcrumb: [
        {
          text: "Fiera Virtuale",
          active: true,
        },
        {
          text: "Lista Stand",
          active: true,
        },
      ],
    },
  },
  {
    path: "/stands/:id",
    name: "Single-Stand",
    component: () => import("@/views/stand/single-stand.vue"),
    meta: {
      pageTitle: "Nome dello Stand",
      breadcrumb: [
        {
          text: "Fiera Virtuale",
          active: true,
        },
        {
          text: "Lista Stand",
          to: "/stands",
          active: false,
        },
        {
          text: "Modifica",
          active: true,
        },
      ],
    },
  },
];
